import React from 'react';
import { BsAward, BsCalendar, BsExclamationTriangle } from 'react-icons/bs';
import { IoIosGlobe } from 'react-icons/io';
import { Container, GridItem, HStack, Icon, Stack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../../../../../../../../../constants/analyticsIds';
import { CypressIds } from '../../../../../../../../../../../constants/cypressIds';
import { getDateString, isPast } from '../../../../../../../../../../../utils/dateUtil';

const PolicyDetailsGrid = ({ policy }) => {
  if (!policy.id) {
    return <GridItem colSpan={1} minW={250} />;
  }

  const policyIsExpired = isPast(policy.expiresAt);

  return (
    <GridItem
      colSpan={1}
      data-cy={CypressIds.policyRow(policy.id)}
      minW={250}
    >
      <Stack direction="column" justifyContent="left" spacing={1}>
        <HStack>
          <Icon
            as={policyIsExpired ? BsExclamationTriangle : BsCalendar}
            color={policyIsExpired ? 'error.primary.600' : 'greyScale.800'}
          />
          <Container color={policyIsExpired ? 'error.primary.600' : 'inherit'} maxW="container.sm" textAlign="left">
            {getDateString(policy.effectiveAt, 'MM/DD/YYYY')}
            {' '}
            -
            {' '}
            {getDateString(policy.expiresAt, 'MM/DD/YYYY')}
          </Container>
        </HStack>
        <HStack>
          <Icon as={BsAward} color="greyScale.800" />
          <Container maxW="inherit" textAlign="left">{policy.number}</Container>
        </HStack>
        <HStack>
          <Icon as={IoIosGlobe} color="greyScale.800" />
          <Container
            color="success.primary.600"
            maxW="container.sm"
            textAlign="left"
          >
            <a
              data-analytics-id={analyticsIds.insuredProfilePage.policiesComponent.openInsuranceCompanyAMBestRating}
              href="http://www3.ambest.com/ratings/entities/SearchResults.aspx?AltSrc=9"
              rel="noreferrer"
              target="_blank"
            >
              {policy.insuranceCompany.companyName}
            </a>
          </Container>
        </HStack>
      </Stack>
    </GridItem>
  );
};

PolicyDetailsGrid.propTypes = { policy: PropTypes.oneOfType([PropTypes.object, PropTypes.array]) };

export default PolicyDetailsGrid;
